import { REQUEST, RESPONSE, FAILURE } from '../../actions/settings/public';

const initial = {
  isLoading: false,
  error:     null,
  // Sensible defaults so consumers can render before the BE
  // response lands (matches the server-side fallback).
  response: {
    credit:   { value_usd: 0.01, currency: 'USD' },
    platform: { marketplace_fee_pct: 30 },
    viewer:   { organizations: [] },
  },
};

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST:
      return { ...state, isLoading: true, error: null };
    case RESPONSE:
      return { ...state, isLoading: false, response: action.payload };
    case FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
